<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import CustomToolGuide from 'dashboard/components-next/captain/pageComponents/customTool/CustomToolGuide.vue';

const emit = defineEmits(['click']);

const onClick = () => {
  emit('click');
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <CustomToolGuide />
    <EmptyStateLayout
      :title="$t('CAPTAIN.CUSTOM_TOOLS.EMPTY_STATE.TITLE')"
      :subtitle="$t('CAPTAIN.CUSTOM_TOOLS.EMPTY_STATE.SUBTITLE')"
      :action-perms="['administrator']"
    >
      <template #empty-state-item>
        <div class="min-h-[600px]" />
      </template>
      <template #actions>
        <Button
          :label="$t('CAPTAIN.CUSTOM_TOOLS.ADD_NEW')"
          icon="i-lucide-plus"
          @click="onClick"
        />
      </template>
    </EmptyStateLayout>
  </div>
</template>
